<template>
  <div class="page-container">
    <el-card>
      <el-row class="room-sticker__title">
        机器人送礼配置
        <el-button type="primary" @click="addStickerBtnHandle(true)" style="float: right">
          新增
        </el-button>
      </el-row>
      <el-row>
        <el-table height="80vh" :data="drawPrizeList" v-loading="requestLoading" border>
          <el-table-column
            prop="sendGiftCount"
            label="送礼次数"
            align="center"
            width="80"
          />
          <el-table-column prop="type" label="房间类型" align="center" width="94">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.type == 0" type="success">所有房间</el-tag>
              <el-tag v-else>指定房间</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="房主ID列表" align="center" width="100">
            <template
              slot-scope="scope"
              v-if="scope.row.ownerIdList && scope.row.ownerIdList.length > 0"
            >
              <div style="display: flex; flex-direction: column; gap: 6px">
                <el-tag
                  v-for="(item, idx) in scope.row.ownerIdList.split(';')"
                  :key="idx"
                  type="success"
                >
                  {{ item }}
                </el-tag>
              </div>
            </template>
          </el-table-column>
          <!-- giftList -->
          <el-table-column label="配置项" align="center" width="fit-content">
            <template slot-scope="scope">
              <!-- 遍历显示图片 -->
              <div style="display: flex; justify-content: center; flex-wrap: wrap">
                <img
                  v-for="(item, idx) in scope.row.giftList"
                  :key="idx"
                  :src="item.iconUrl"
                  alt=""
                  style="width: 50px; height: 50px"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="durationStart"
            label="开播时长范围开始时间"
            width="100"
            align="center"
          >
            <template slot-scope="scope"> {{ scope.row.durationStart }}s</template>
          </el-table-column>
          <el-table-column
            prop="durationEnd"
            label="开播时长范围结束时间"
            width="100"
            align="center"
          >
            <template slot-scope="scope"> {{ scope.row.durationEnd }}s</template>
          </el-table-column>
          <el-table-column
            prop="sendGiftIntervalStart"
            label="送礼间隔范围开始时间"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.sendGiftIntervalStart }}s</template
            >
          </el-table-column>
          <el-table-column
            prop="sendGiftIntervalEnd"
            label="送礼间隔范围结束时间"
            width="100"
            align="center"
          >
            <template slot-scope="scope"> {{ scope.row.sendGiftIntervalEnd }}s</template>
          </el-table-column>

          <el-table-column prop="fixDate" width="100" label="修改时间" align="center" />
          <el-table-column
            prop="createDate"
            width="100"
            label="创建时间"
            align="center"
          />
          <el-table-column prop="valid" width="94" label="状态" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.valid == 1" type="success">正在运行</el-tag>
              <el-tag v-else type="danger">已停止</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="operator" label="操作人" width="94" align="center" />
          <el-table-column label="操作" bbalign="center" width="74">
            <template slot-scope="scope">
              <!-- 开始/停止 -->
              <div style="display: flex; flex-direction: column; gap: 6px">
                <el-button
                  v-if="scope.row.valid == 1"
                  size="mini"
                  style="color: #ec493f"
                  @click="uploadReqBtnHandle(1, scope.row)"
                  >停止
                </el-button>
                <el-button
                  v-else
                  style="color: #5bb65b"
                  size="mini"
                  @click="uploadReqBtnHandle(1, scope.row)"
                  >开始
                </el-button>
                <el-button
                  type="primary"
                  size="mini"
                  style="margin: 0"
                  @click="addStickerBtnHandle(false, scope.row)"
                  >编辑
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row>
        <el-pagination
          :current-page.sync="pageInfo.page"
          layout="total, prev, pager, next"
          background
          @current-change="handleCurrentChange"
          :total="pageInfo.total"
          class="pagination"
          :page-size="30"
        >
        </el-pagination>
      </el-row>
    </el-card>
    <el-dialog
      :title="isAdd ? '新增' : '编辑'"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleDialogClose"
    >
      <el-form :model="submitForm" label-width="180px">
        <el-form-item label="房间类型" prop="type" v-if="isAdd">
          <el-radio-group v-model="submitForm.type">
            <el-radio label="0">所有房间</el-radio>
            <el-radio label="1">指定房间</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 指定房间输入id -->
        <el-form-item
          label="房主ID列表"
          prop="ownerIdList"
          v-if="submitForm.type == '1' && isAdd"
        >
          <el-input
            type="textarea"
            placeholder="请输入房间ID，多个房间用;分隔"
            v-model="submitForm.ownerIdList"
          />
        </el-form-item>
        <el-form-item label="是否有效" prop="valid" v-if="!isAdd">
          <el-radio-group v-model="submitForm.valid">
            <el-radio label="1">有效</el-radio>
            <el-radio label="0">无效</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="开播时长范围结束时间" prop="durationEnd">
          <el-input placeholder="请输入时长范围" v-model="submitForm.durationEnd" />
        </el-form-item>
        <el-form-item label="开播时长范围开始时间" prop="durationStart">
          <el-input placeholder="请输入时长范围" v-model="submitForm.durationStart" />
        </el-form-item>
        <el-form-item label="送礼次数" prop="sendGiftCount">
          <el-input v-model="submitForm.sendGiftCount" placeholder="请输入赠礼次数" />
        </el-form-item>
        <el-form-item label="送礼间隔范围结束时间" prop="sendGiftIntervalEnd">
          <el-input
            placeholder="请输入间隔时长范围"
            v-model="submitForm.sendGiftIntervalEnd"
          />
        </el-form-item>
        <el-form-item label="送礼间隔范围开始时间" prop="sendGiftIntervalStart">
          <el-input
            placeholder="请输入间隔时长范围"
            v-model="submitForm.sendGiftIntervalStart"
          />
        </el-form-item>

        <el-form-item label="随机赠送指定礼物ID" prop="giftIds">
          <el-input
            v-model="giftId"
            placeholder="请输入礼物ID"
            style="width: 200px; margin-right: 10px"
          />
          <el-button @click="addGift" type="primary">添加</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="giftList" style="width: 100%" border v-if="giftList.length">
        <el-table-column prop="giftId" label="礼物ID" align="center" />
        <el-table-column prop="giftName" label="礼物名称" align="center" />
        <el-table-column prop="giftIcon" label="礼物图标" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.iconUrl" alt="" style="width: 50px; height: 50px" />
          </template>
        </el-table-column>
        <el-table-column prop="price" label="礼物价格" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="danger"
              size="mini"
              @click="giftList.splice(scope.$index, 1)"
            >
              移除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadReqBtnHandle(0)" type="primary" v-if="isAdd">
          新 增
        </el-button>
        <el-button
          v-loading="requestLoading"
          @click="uploadReqBtnHandle(1)"
          type="primary"
          v-else
        >
          更 新
        </el-button>
        <el-button @click="handleDialogClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      requestLoading: false,
      // 总页数
      pageInfo: {
        page: 1,
        total: 0,
      },
      // 数据列表
      drawPrizeList: [],
      submitForm: {
        durationEnd: "",
        durationStart: "",
        sendGiftIntervalEnd: "",
        sendGiftIntervalStart: "",
        sendGiftCount: "",
        giftIds: "",
        type: "0",
        ownerIdList: "",
      },
      dialogVisible: false,
      isAdd: true,

      giftId: "",
      giftList: [],
    };
  },

  methods: {
    async query(page) {
      if (page) this.pageInfo.page = 1;
      this.requestLoading = true;
      const { data: res } = await this.$axios.get(
        this.$store.getters.path.robot_gift_query +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
        {
          params: {
            page: this.pageInfo.page,
          },
        }
      );
      if (res.code !== 0) return this.$message.error(res.msg);
      this.drawPrizeList = res.data.data;
      this.pageInfo.total = res.data.total;
      this.requestLoading = false;
    },
    // 新增按钮处理
    addStickerBtnHandle(add, row) {
      this.isAdd = add;
      if (!add) {
        row.valid = row.valid.toString();
        row.type = row.type.toString();
        this.giftList = row.giftList;
        // this.giftList 遍历，将showName赋值给giftName
        this.giftList.forEach((item) => {
          item.giftName = item.showName;
        });
        this.submitForm = { ...row };
      }
      this.dialogVisible = true;
    },
    // 新增/修改提交按钮处理
    async uploadReqBtnHandle(label, row) {
      if (row) {
        // 说明是停止/开始操作 valid 取反，然后row赋值给submitForm
        this.submitForm = { ...row, valid: row.valid == 1 ? 0 : 1 };
      } else {
        // 处理giftIds
        this.submitForm.giftIds = this.giftList.map((item) => item.giftId).join(",");
      }
      let url = null;
      if (label === 0) {
        url =
          this.$store.getters.path.robot_gift_add +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token;
      } else {
        url =
          this.$store.getters.path.robot_gift_edit +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token;
      }

      if (this.submitForm.type === "0") {
        delete this.submitForm.ownerIdList;
      }
      const { data: res } = await this.$axios.post(url, { ...this.submitForm });
      if (res.code != 0) return this.$message.error(res.msg);
      this.handleDialogClose();
      this.query();
      this.$message.success(res.msg);
    },
    async addGift() {
      const { data: res } = await this.$axios({
        method: "post",
        url: this.$store.getters.path.config_gift_query,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          giftId: this.giftId,
          page: 1,
          giftType: 3,
        },
      });

      if (res.code != 0 || res.data.data.length < 1)
        return this.$message("没找到指定的礼物");
      this.giftList.push(res.data.data[0]);
      this.giftId = "";
    },
    handleCurrentChange(index) {
      this.pageInfo.page = index;
      this.query();
    },

    // 弹窗关闭事件
    handleDialogClose() {
      this.submitForm = {
        durationEnd: "",
        durationStart: "",
        sendGiftIntervalEnd: "",
        sendGiftIntervalStart: "",
        sendGiftCount: "",
        ownerIdList: "",
        giftIds: "",
        type: "0",
      };
      this.dialogVisible = false;
      this.giftList = [];
      this.giftId = "";
    },
  },
  mounted() {
    this.query();
  },
};
</script>
<style scoped lang="scss">
.room-sticker {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    .el-select {
      margin-right: 10px;
    }
  }
}

.item {
  display: flex;
  margin: 10px 0;
  align-items: center;

  .el-input {
    margin-left: 10px;
  }

  span {
    width: 100px;
  }
}
.card {
  margin: 20px 0;
  height: 90vh;
}
</style>
